import React, { useMemo, useRef, useState } from 'react';
import CallButtonBar from '../../components/call/CallButtonBar';
import MediaModal from './modals/MediaModal';
import SearchModal from './modals/SearchModal';
import HeaderChatMenu from './HeaderChatMenu';

const HeaderChatUI = ({ chat, userId, chatId, onBack }) => {
    const peerId = useMemo(() => {
        if (!chat || !userId) return null;
        if (chat.user?._id) return chat.user._id;
        if (Array.isArray(chat.participants)) {
            const me = String(userId);
            const other = chat.participants.find(id => String(id?._id || id) !== me);
            return other?._id || other || null;
        }
        return null;
    }, [chat, userId]);

    const peerName = useMemo(() => {
        if (chat?.user) return `${chat.user.firstName || ''} ${chat.user.lastName || ''}`.trim();
        if (chat?.isGroup) return chat.title || `Комната #${String(chatId || '').slice(-5)}`;
        if (Array.isArray(chat?.participants)) {
            const meId = String(userId);
            const other = chat.participants.find(p => String((p?._id || p)) !== meId);
            if (!other) return 'Собеседник';
            if (typeof other === 'object') return `${other.firstName || ''} ${other.lastName || ''}`.trim() || 'Собеседник';
            return 'Собеседник';
        }
        return 'Собеседник';
    }, [chat, userId, chatId]);

    const toggleFullscreen = async () => {
        if (!document.fullscreenElement) { try { await document.documentElement.requestFullscreen(); } catch { } }
        else { try { await document.exitFullscreen(); } catch { } }
    };

    const [menuOpen, setMenuOpen] = useState(false);
    const btnRef = useRef(null);

    const [media, setMedia] = useState({ open: false, type: 'image' });
    const [searchOpen, setSearchOpen] = useState(false);

    // колбэки для HeaderChatMenu
    const handleOpenMedia = (type) => {
        // setMenuOpen(false);
        console.log("open media", type);

        setMedia({ open: true, type });
    };

    const handleOpenSearch = () => {
        console.log("open search");
        // setMenuOpen(false);
        setSearchOpen(true);
    };
    console.log("searchOpen", searchOpen);
    console.log("media", media);
    return (
        <div className="ChatUI__header">
            <div className="ChatUI__header-left">
                {onBack && <button className="iconBtn" onClick={onBack} title="Назад">←</button>}
                <div className="name">{peerName || `Чат #${String(chatId || '').slice(-5)}`}</div>
            </div>

            <div className="actions" style={{ display: 'flex', gap: 8 }}>
                <button className="iconBtn" onClick={toggleFullscreen} title="На весь экран">⛶</button>

                <button
                    ref={btnRef}
                    className="iconBtn"
                    onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setMenuOpen(v => !v); }}
                    title="Меню"
                >⋯</button>

                {/* Меню теперь единое и переиспользуемое */}
                <HeaderChatMenu
                    chatId={chatId}
                    anchorRightRef={btnRef}
                    open={menuOpen}
                    onClose={() => setMenuOpen(false)}
                    // отключаем встроенный поисковый Redux и медиа-фильтрацию,
                    // вместо этого открываем модалки
                    onSearch={() => handleOpenSearch()}
                    onFilter={(type) => handleOpenMedia(type)}
                    showSearch={true}
                    showMedia={true}
                    width={300}
                />

                <CallButtonBar
                    peerId={peerId}
                    peerName={peerName}
                    chatId={chatId}
                    isGroup={!!chat?.isGroup}
                />
            </div>

            {media.open && (
                <MediaModal
                    chatId={chatId}
                    type={media.type}
                    onClose={() => setMedia({ open: false, type: 'image' })}
                />
            )}

            {searchOpen && (
                <SearchModal
                    chatId={chatId}
                    onClose={() => setSearchOpen(false)}
                />
            )}
        </div>
    );
};

export default HeaderChatUI;
